import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'unixTimeToDate',
    standalone: false,
})
export class UnixTimeToDatePipe implements PipeTransform {
    transform(time: number, format: string): string {
        return moment.unix(time).format(format);
    }
}
